import  { ReactNode } from 'react';

interface TitleWithContentProps {
    title: string;
    children?: ReactNode; // Adjusted to accept ReactNode
}

const TitleWithContent = ({ title, children }: TitleWithContentProps) => {
    return (
        <>
            <div style={{
                 paddingLeft: "clamp(.2rem, 10vw, 15rem)",
                 paddingRight: "clamp(.2rem, 10vw, 15rem)",
                 paddingTop: "clamp(.2rem, 2vw, 4rem)",
                 paddingBottom: "clamp(.2rem, 2vw, 4rem)",      
            }}
            className="group tracking-tight">
                <p
                className="h1 font-bold ">{title}</p>
                <div style={{
                    marginBottom: "clamp(0.2rem, 2vw, 1rem)",
                }} className="">
                    <h1></h1>
                </div>
                {children} 
            </div>
        </>
    );
};

export default TitleWithContent;
